import { createUseStyles } from 'react-jss';

type StyleProps = {
  isHyperLink?: boolean;
};

const useStyles = createUseStyles<string, StyleProps>(
  () => {
    return {
      button: ({ isHyperLink }) =>
        isHyperLink ? { paddingLeft: 0, cursor: 'pointer' } : { cursor: 'pointer' },
    };
  },
  {
    name: 'button-wrapper',
  },
);

export default useStyles;
